import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/app.css';
import { App } from './App';
import { AuthProvider } from './state/AuthContext';
import { FamilyProvider } from './state/FamilyContext';
import { ThemeProvider } from './state/ThemeContext';
import { ToastProvider } from './components/Toast';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <FamilyProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </FamilyProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
